import React, { Fragment } from 'react'

import router from 'next/router'

import CardView from '@nexys/components/CardView/CardView'
import moment from '@nexys/helpers/DateMoment'
import { Button, Col, Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { Title } from 'shortcuts/Typography'

import useGetAllAnnouncement from 'data/useGetAllAnnouncement'
import { getImagePath } from 'utils/imagePath'

import classNames from 'views/Home/partials/HighlightPost.module.scss'

export default function Announcement() {
  const { xs, lg } = useBreakpoint()

  const { data = [] } = useGetAllAnnouncement(1, 10, null, 'getAll')

  return (
    <Fragment>
      <Row style={{ display: 'flex', flexDirection: 'column' }}>
        <Col lg={24}>
          <Row
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: '23px',
            }}
            className={'mx-auto'}
          >
            <Col>
              <Title
                style={{
                  fontSize: xs ? '20px' : '36px',
                  color: '#2C2C2C',
                  fontFamily: 'Inter-Bold',
                  fontWeight: '700',
                }}
              >
                Pengumuman
              </Title>
            </Col>
            {lg && (
              <Col>
                <Button
                  style={{ color: '#985ECF' }}
                  className={classNames.buttonDefault}
                  onClick={() => {
                    router.push('/pengumuman')
                  }}
                >
                  Lihat Semua
                </Button>
              </Col>
            )}
          </Row>
        </Col>
        <Col lg={24} className={classNames.myActivity}>
          {data.slice(0, 6).map((dt) => {
            return (
              <CardView
                text={dt?.tittle}
                createdDate={moment.formatDateDay(dt?.createdAt)}
                img={getImagePath(dt?.imagePath)}
                onClick={() => {
                  router.push(`/pengumuman/${dt?.tittle}`)
                }}
              />
            )
          })}
        </Col>
        {!lg && (
          <Col className="mx-auto">
            <Button
              style={{ color: '#985ECF' }}
              className={classNames.buttonDefault}
              onClick={() => {
                router.push('/pengumuman')
              }}
            >
              Lihat Semua
            </Button>
          </Col>
        )}
      </Row>
    </Fragment>
  )
}
